<template>
  <div>
    <div class="reply-container">
      <p class="notification-subtitle paddingBottom no-margin">Event title (Max 100 characters)</p>
      <div class="counter-wrapper">
        <VTextField
          v-model="localTitle"
          placeholder="Enter text"
          :maxlength="100"
          aria-label="Enter event title"
          appearance="ghost"
          class="vivid-input"
          @blur="emitChange"
        ></VTextField>
        <div class="custom-counter">{{ (localTitle || '').length }}/100</div>
      </div>
    </div>

    <div class="reply-container">
      <p class="notification-subtitle paddingBottom no-margin">Event description (optional)</p>
      <div class="counter-wrapper">
        <VTextArea
          v-model="localDescription"
          placeholder="Description of the calendar event"
          :maxlength="500"
          aria-label="event description"
          appearance="ghost"
          class="vivid-textarea"
          :rows="4"
          @blur="emitChange"
        ></VTextArea>
        <div class="custom-counter">{{ (localDescription || '').length }}/500</div>
      </div>
    </div>

    <div class="datetime-range-infoBanner infoBanner">
      <div class="text">
        <b>Note:</b> Selected date and time must be at least 2 hours in the future.
      </div>
    </div>

    <div class="flex-between">
      <div class="flex100P">
        <p class="notification-subtitle paddingBottom no-margin">Start Date &amp; Time</p>
        <DateTime
          id="calendar-start-datetime"
          v-model="localStart"
          :minValidation="{ enabled: true, value: 2, type: 'hours' }"
          :maxValidation="{ enabled: true, value: 12, type: 'months' }"
          @update:modelValue="emitChange"
        ></DateTime>
      </div>
      <div class="flex100P">
        <p class="notification-subtitle paddingBottom no-margin">End Date &amp; Time</p>
        <DateTime
          id="calendar-end-datetime"
          v-model="localEnd"
          :minValidation="{ enabled: true, value: 2, type: 'hours' }"
          :maxValidation="{ enabled: true, value: 12, type: 'months' }"
          @update:modelValue="emitChange"
        ></DateTime>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import DateTime from '@/components/DateTime.vue';

export interface CalendarPayload {
  title: string
  description: string
  start: string | undefined
  end: string | undefined
}

const props = defineProps<{
  modelValue: CalendarPayload
}>();

const emit = defineEmits<{
  'update:modelValue': [value: CalendarPayload]
}>();

const localTitle = ref(props.modelValue.title);
const localDescription = ref(props.modelValue.description);
const localStart = ref<string | undefined>(props.modelValue.start);
const localEnd = ref<string | undefined>(props.modelValue.end);

watch(() => props.modelValue, (val) => {
  localTitle.value = val.title;
  localDescription.value = val.description;
  localStart.value = val.start;
  localEnd.value = val.end;
}, { deep: true });

function emitChange() {
  emit('update:modelValue', {
    title: localTitle.value,
    description: localDescription.value,
    start: localStart.value,
    end: localEnd.value,
  });
}
</script>

<style scoped>
.reply-container {
  margin-bottom: 15px;
  margin-top: 15px;
}
.paddingBottom {
  padding-bottom: 10px;
}
.no-margin {
  margin: 0;
}
.datetime-range-infoBanner {
  margin-bottom: 10px;
}
.infoBanner {
  background-color: var(--purple-opac);
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  gap: 5px;
  font-size: 0.9rem;
  border-radius: 5px;
}
.flex-between {
  display: flex;
  gap: 10px;
}
.flex100P {
  flex: 1;
}
</style>
